import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import App from './App';
import './index.css';

const key = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

ReactDOM.createRoot(document.getElementById('root')).render(
  <ClerkProvider publishableKey={key}
    appearance={{
      layout: {
        socialButtonsPlacement: 'top',
      },
      variables: {
        colorPrimary: '#00D4AA',
        colorBackground: '#0A0F1E',
        colorText: '#FFFFFF',
        colorTextSecondary: '#FFFFFF',
        colorInputBackground: '#141B2D',
        colorInputText: '#FFFFFF',
        borderRadius: '8px',
      },
      elements: {
  card: {
    background: '#141B2D',
    border: '1px solid #1a2640',
    boxShadow: '0 0 40px rgba(0,212,170,0.1)',
  },
  // Add these for the UserButton dropdown
  userButtonPopoverCard: {
    background: '#141B2D',
    border: '1px solid #1a2640',
  },
  userButtonPopoverActionButton: {
    color: '#FFFFFF',
  },
  userButtonPopoverActionButtonText: {
    color: '#FFFFFF',
  },
  userButtonPopoverActionButtonIcon: {
    color: '#FFFFFF',
  },
  userButtonPopoverFooter: {
    background: '#0A0F1E',
    borderTop: '1px solid #1a2640',
  },
  userPreviewMainIdentifier: {
    color: '#FFFFFF',
  },
  userPreviewSecondaryIdentifier: {
    color: '#8899aa',
  },
  // rest of existing elements...
  socialButtonsBlockButton: {
    color: '#FFFFFF',
    background: '#1a2640',
    border: '1px solid #2a3650',
  },
  socialButtonsBlockButtonText: {
    color: '#FFFFFF',
  },
  dividerText: {
    color: '#8899aa',
  },
  formFieldLabel: {
    color: '#FFFFFF',
  },
  footerActionText: {
    color: '#8899aa',
  },
  footerActionLink: {
    color: '#00D4AA',
  },
}
    }}>
    <App />
  </ClerkProvider>
);